export class SC_SubFileType {
    static readonly NULL = 0;
    static readonly AUTO_INSURE = 1;
    static readonly GENERAL_LIAB = 2;
    static readonly WORK_COMP = 4;
    static readonly W9 = 8;
    static readonly SUB_FORM = 16;

    constructor(private service: number = SC_SubFileType.NULL) { }

    static fromAPI(apiValue: string): SC_SubFileType {
        switch (Number(apiValue)) {
            case SC_SubFileType.AUTO_INSURE:
                return new SC_SubFileType(SC_SubFileType.AUTO_INSURE);
            case SC_SubFileType.GENERAL_LIAB:
                return new SC_SubFileType(SC_SubFileType.GENERAL_LIAB);
            case SC_SubFileType.WORK_COMP:
                return new SC_SubFileType(SC_SubFileType.WORK_COMP);
            case SC_SubFileType.W9:
                return new SC_SubFileType(SC_SubFileType.W9);
            case SC_SubFileType.SUB_FORM:
                return new SC_SubFileType(SC_SubFileType.SUB_FORM);
            default:
                return new SC_SubFileType();
        }
    }

    is(type: number): boolean {
        return this.service === type;
    }

    toAPI(): number {
        return this.service;
    }

    clone(): SC_SubFileType {
        return new SC_SubFileType(this.service);
    }

    /**
     * Merges another SC_SubFileType object into this one, replacing null fields
     */
    merge(other: SC_SubFileType): SC_SubFileType {
        if (other.service !== SC_SubFileType.NULL) {
            this.service = other.service;
        }

        return this;
    }

    static readonly originator = [
        { key: SC_SubFileType.AUTO_INSURE, display: "Auto Insurance" },
        { key: SC_SubFileType.GENERAL_LIAB, display: "General Liability" },
        { key: SC_SubFileType.WORK_COMP, display: "Work Comp" },
        { key: SC_SubFileType.W9, display: "W9" },
        { key: SC_SubFileType.SUB_FORM, display: "Sub Form" },
    ];

    toString(): string {
        switch (this.service) {
            case SC_SubFileType.AUTO_INSURE:
                return "Auto Insurance";
            case SC_SubFileType.GENERAL_LIAB:
                return "General Liability";
            case SC_SubFileType.WORK_COMP:
                return "Work Comp";
            case SC_SubFileType.W9:
                return "W9";
            case SC_SubFileType.SUB_FORM:
                return "Sub Form";
            default:
                return "UNKNOWN";
        }
    }
}
